export default "__VITE_ASSET__d7f0a31a__"